<template>
    <div class="receipt-wrap">
        <template v-if="listArr.length  > 0">   
            <div class="receipt-item" v-for="item in listArr" :key="item.source_id">
                <img src="@/assets/images/invoice.png" alt="">
                <div class="text-right">
                    <div class="amount mgb10">
                        <span>￥{{item.amount}}</span> {{item.status_text}}
                    </div>
                    <div class="desc mgb10 over-ell">{{item.title}}</div>
                    <div class="number mgb10 over-ell">{{item.tax_number}}</div>
                    <div class="time mgb10">{{item.ctime_text}}</div>
                </div>
            </div>
        </template>
        <div v-else>暂无数据</div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            listArr: []
        }
    },
    mounted() {
        this.list()
    },
    methods: {
        list() {
            this.$api.myinvoIcelist().then(res => {
                console.log(res.data.list)
                this.listArr = res.data.list
			});
        }
    }
}
</script>

<style lang="scss" scoped>
.mgb10 {
    margin-bottom: 10px;
}
.over-ell {
    width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.receipt-wrap {
    display: flex;
    flex-wrap: wrap;
}
.receipt-item {
    background: linear-gradient(to right, #ff6565, #ff8a8a);
    color: #fff;
    display: flex;
    padding: 20px 20px 20px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    img {
        width: 69px;
        height: 72px;
        margin-right: 10px;
    }
    .amount {
        span {
            font-size: 18px;
        }
    }
}
</style>>